import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { WhatsAppFAB } from './WhatsAppFAB';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background">
      {/* Noise overlay */}
      <div className="noise-overlay" />
      
      <Navbar />
      <main>{children}</main>
      <Footer />
      <WhatsAppFAB />
    </div>
  );
};
